export const useAuthStore = defineStore(
	"authStore",
	() => {
		const isAuthenticated = ref(false)
		const token = ref("")
		const expiresAt = ref(0)

		const setIsAuthenticated = (value: boolean) => {
			isAuthenticated.value = value
			updateExpiresAt()
		}
		const setToken = (value: string) => (token.value = value)

		const updateExpiresAt = () => {
			expiresAt.value = recalculateExpiresAt()
		}

		const recalculateExpiresAt = () => {
			//Tokens are valid for 1 hour
			return new Date().getTime() + 60 * 60 * 1000
		}

		const isTokenExpired = () => {
			const now = new Date().getTime()
			const isExpired = expiresAt.value > 0 ? expiresAt.value < now : false
			if (isExpired) {
				$reset()
			}
			return isExpired
		}

		const $reset = () => {
			isAuthenticated.value = false
			token.value = ""
			expiresAt.value = 0
		}

		return {
			isAuthenticated,
			setIsAuthenticated,
			token,
			setToken,
			expiresAt,
			isTokenExpired,
			updateExpiresAt,
			$reset,
		}
	},
	{
		persist: {
			key: "up_authStore", // Make sure this key is unique
			storage: localStorage, // or cookies if you're using cookie storage
		},
	},
)
